import Ajv from 'ajv';
import QuizSchema from '../schemas/quiz.schema.json';

const ajv = new Ajv();

export const quizValidator = ajv.compile(QuizSchema);

export default { quizValidator };
